const ReportShareCard = ({ preview }) => {
  const { snippet, citation_count, last_updated } = preview || {};
  const formattedDate = last_updated
    ? new Date(last_updated).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <div className="space-y-2">
      {snippet && (
        <p className="text-[12px] font-light text-mutedText/80 leading-relaxed line-clamp-2">
          {snippet}...
        </p>
      )}
      <div className="flex items-center gap-x-3 text-[11px] font-light text-mutedText/60">
        {citation_count > 0 && <span>{citation_count} citations</span>}
        {citation_count > 0 && formattedDate && <span>&middot;</span>}
        {formattedDate && <span>Updated {formattedDate}</span>}
      </div>
    </div>
  );
};

export default ReportShareCard;
